import { render, staticRenderFns } from "./GiftCard.vue?vue&type=template&id=f8d80b98&"
import script from "./GiftCard.vue?vue&type=script&lang=ts&"
export * from "./GiftCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8d80b98')) {
      api.createRecord('f8d80b98', component.options)
    } else {
      api.reload('f8d80b98', component.options)
    }
    module.hot.accept("./GiftCard.vue?vue&type=template&id=f8d80b98&", function () {
      api.rerender('f8d80b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/giftcard/GiftCard.vue"
export default component.exports